import { render } from "./InnovacionView.vue?vue&type=template&id=6b7ee44c"
import script from "./InnovacionView.vue?vue&type=script&lang=js"
export * from "./InnovacionView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__